import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import HomePageOne from "./pages/HomePageOne";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import ShopPage from "./pages/ShopPage";
import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
import CartPage from "./pages/CartPage";
// import CheckoutPage from "./pages/CheckoutPage";
import AccountPage from "./pages/AccountPage";
import ContactPage from "./pages/ContactPage";
import MyContextProvider from "./MyContext/MyContextProvider";
import Loader from "./helper/Loader";
import { useEffect, useState, useContext } from "react";
import HeaderOne from "./components/HeaderOne";
import ResetPassword from "./components/ResetPassword";
import NotFound from "./pages/NotFound";
import MyContext from "./MyContext/MyContext";

import PrivateAdminRoute from "./MyContext/PrivateAdminRoute";
import AdminPanel from "./pages/AdminPanel";
import AdminLogin from "./components/AdminLogin";

const LoaderWrapper = ({ children }) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 800);

    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return isLoading ? <Loader /> : children;
};

function AppContent() {
  const location = useLocation();
const hideHeader =
  location.pathname.startsWith("/reset-password") ||
  location.pathname.startsWith("/admin") ||
  location.pathname.startsWith("/admin-login");


  const { user, authLoading } = useContext(MyContext);

  if (authLoading) return null;

  return (
    <>
      <RouteScrollToTop />
      {!hideHeader && <HeaderOne />}
      <PhosphorIconInit />

      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/" element={<HomePageOne />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/shop/:category" element={<ShopPage />} />
        <Route path="/shop/:category/:productId" element={<ProductDetailsPageOne />} />
        <Route path="/cart" element={<CartPage />} />
        {/* <Route path="/checkout" element={<CheckoutPage />} /> */}

        <Route
          path="/account"
          element={!user ? <AccountPage /> : <Navigate to="/" replace />}
        />

        <Route path="/contact" element={<ContactPage />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="*" element={<NotFound />} />

        {/* ADMIN AUTH ROUTES */}
        <Route path="/admin-login" element={<AdminLogin />} />

        {/* PROTECTED ADMIN ROUTE */}
        <Route
          path="/admin"
          element={
            <PrivateAdminRoute>
              <AdminPanel />
            </PrivateAdminRoute>
          }
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <MyContextProvider>
        <LoaderWrapper>
          <AppContent />
        </LoaderWrapper>
      </MyContextProvider>
    </BrowserRouter>
  );
}

export default App;
